import { render } from "./Form.vue?vue&type=template&id=1e4df03b"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=1e4df03b&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__